import { BlockReleaseApiResponse } from '@data/blockReleases/types/BlockRelease.types';
import { sortObjectsByField } from '@utilities/sortObjectsByField/sortObjectsByField';

export const sortBlockReleases = (
	blockReleases: BlockReleaseApiResponse[]
): BlockReleaseApiResponse[] => {
	if (!blockReleases.length) {
		return [];
	}

	return blockReleases.sort((a, b) => {
		return (
			sortObjectsByField('startDateTime')(a, b) ||
			sortObjectsByField('blockStartTime')(a, b) ||
			sortObjectsByField('slotName')(a, b)
		);
	});
};
